module.exports = "<app-entry-list></app-entry-list>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Aimee/Desktop/git/Angular/aimees-photo-blog/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main